import { IAccessCredentialListItem } from "./access-credential";
import { IShardRepository, IUpdateShardRepositoryRequest } from "./shard-repository";
import { IBucketDetailsItem, IBucketListItem, IBucketUpdateRequest } from "./bucket";
import { IEntity } from "./id-name";
import { IShardClusterDetailsItem } from "./shard-cluster";

export interface IImportValidationStatus {
    status: boolean;
    message?: string;
    entityType?: ImportEntityType;
    conflictingEntities?: IShardRepository[] | IBucketListItem[] | IShardClusterDetailsItem[];
    importEntities?: IUpdateShardRepositoryRequest[] | IBucketUpdateRequest[] | IShardClusterDetailsItem[];
}

export interface IImportValidationSuccessStatus {
    status: true;
    importedEntities?: {
        storagePool: IShardClusterDetailsItem;
        storageNodes: IShardRepository[];
        bucket: IBucketDetailsItem;
        accessCredential: IAccessCredentialListItem;
    }
}

export enum ImportEntityType {
    StorageNode = 1,
    Bucket = 2,
    StoragePool = 3,
    AccessCredential = 4,
}

export const importEntityTypeDict = {
    [ImportEntityType.StorageNode]: "Shard Repository",
    [ImportEntityType.Bucket]: "Bucket",
    [ImportEntityType.StoragePool]: "Shard Cluster",
    [ImportEntityType.AccessCredential]: "Access Credential"
}

export type ImportError = IEntity & IImportValidationStatus;
